import React, { useEffect, useState } from "react";
import { Section } from "../../Core/Section";
import Header from "../../Core/Header";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  allProductToSell,
  assignServiceBoy,
  createDeliveryForSell,
  dispatchCheckoutHandle,
  getCheckoutList,
  getCouriersListApi,
  getServiceBoyList,
} from "../../Services/Operations/ProductAPI";
import { toast } from "react-toastify";
import { baseURL } from "../../Services/api_endpoints";


const OrderAddSerialNumber = () => {
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.token);

  const [conformedCheckout, setConformedCheckout] = useState([]);
  const [dispatchedCheckout, setDispatchedCheckout] = useState([]);
  const [serviceBoys, setServiceBoys] = useState([]);
  const [availableProducts, setAvailableProducts] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  const [addingModal, setAddingModal] = useState(null);
    const [deliveryAssign, setDeliveryAssign] = useState(null);
  const [itemId, setItemId] = useState(null);
  const [commonuserId, setCommonUserId] = useState(null);
  const [serialNumbers, setSerialNumbers] = useState([]);
  const [load, setLoad] = useState(false);
    const [courierList, setCourierList] = useState([]);
    const [selectedCourier, setSelectedCourier] = useState(null);

    const [trackingNumber, setTrackingNumber] = useState("");
    const [deliveryCost, setDeliveryCost] = useState("");
    const [remarks, setRemarks] = useState("");
    const [expectedDeliveryDate, setExpectedDeliveryDate] = useState(null);
    const [pickupDateTime, setPickupDateTime] = useState(null);
    const [pickupAddress, setPickupAddress] = useState("");

  const fetchCheckouts = async () => {
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const response = await getCheckoutList(token);
      console.log("Checkout List: ", response);

      let list = response.filter(
        (item) => item.orderStatus === "DISPATCHED"
      );
      setDispatchedCheckout(list);

      let confirmedList = response.filter(
        (item) => item.orderStatus !== "DISPATCHED"
      );
      setConformedCheckout(confirmedList);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchServieBoys = async () => {
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const response = await getServiceBoyList(token);
      console.log("serice boy List: ", response);
      setServiceBoys(response);
    } catch (error) {
      console.log(error);
    }
  };
   const fetchCourierList = async () => {
      try {
        const response = await getCouriersListApi(token);
  
        console.log(" courier list", response);
  
        if (response.status === 200) {
          setCourierList(response.data);
        }
      } catch (error) {
        console.log(error);
      }
    };

  const allProductAvailableToSell = async () => {
    try {
      const res = await allProductToSell(token);
      console.log(res);

      if (res.status === 200) {
        setAvailableProducts(res.data);
        console.log("setAvailableProducts : ", res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const addingServiceBoy = async (payload) => {
    try {
      setCommonUserId(payload.commonuserId);
      if(pickupDateTime===""||pickupAddress===""||expectedDeliveryDate===""){
  toast.warn("Fill the form of delivery details")
  return
      }
      const data={
           deliveryAddress: `${activeCheckout.address},${activeCheckout.city},${activeCheckout.district},${activeCheckout.pincode}`,
          dropoffDateTime: expectedDeliveryDate,
          pickupDateTime,
          pickupAddress,
           commonuserId: payload?.commonuserId,
           employeeId: payload?.employeeId,
           sellId: payload?.sellId,
           serviceType: "DELIVERY",
      }
      console.log(data);
      
      const response = await assignServiceBoy(token, data);
      console.log("add service boy response:", response);

      if (response.status === 200) {
        toast.success("Service boy Assigned");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setAddingModal(null);
    }
  };

  const dispatchCheckout = async (data) => {
    try {
      setLoad(true);
      console.log(data);

      if (serialNumbers.length === 0) {
        toast.info("serial number not selected");
        return;
      }

      const response = await dispatchCheckoutHandle(token, data);
      console.log(response);

      if (response.status === 200) {
        toast.success("Dispatched successfully");
        fetchCheckouts();
        setActiveIndex(null);
        setAddingModal(null);
      }
    } catch (error) {
      toast.error("failed to dispatch");
      console.log(error);
    } finally {
      setLoad(false);
    }
  };

  const handleAddSerialNumber = async (data) => {
    setSerialNumbers((items) => [...items, data]);
    toast.success("serial number added");
    setAddingModal(null);
  };

  const undoSerialNumber = async (data) => {
    let list = serialNumbers.filter(
      (item) => item.serialNumber !== data.serialNumber
    );
    setSerialNumbers(list);
    toast.success("serial number removed");
    setAddingModal(null);
  };

  const dateFormate = (date) => {
    let d = new Date(date);
    return d.toLocaleDateString();
  };

  const findServiceboy = (id) => {
    if (!id) {
      return "not found";
    }

    let boy = serviceBoys.find((item) => item.employeeId === id);
    return boy.firstName;
  };

  function generateRandomString() {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";

    for (let i = 0; i < 10; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return result;
  }
    const handleAssignCourier = async () => {
      try {
        let data = {
          sellId: deliveryAssign.sellId,
          deliveryAddress: `${deliveryAssign.address},${deliveryAssign.city},${deliveryAssign.district},${deliveryAssign.pincode}`,
          dropoffDateTime: expectedDeliveryDate,
          pickupDateTime,
          pickupAddress,
          courierDetails: {
            courierId: selectedCourier.id,
            trackingNumber,
            expectedDeliveryDate,
            remarks,
            deliveryCost,
            status:1
          },
        };
  
        const response = await createDeliveryForSell(data, token);
  
        console.log(response);
  
        if (response.status === 200) {
          setDeliveryAssign(null);
          toast.success("Courier assigned successfully");
        
        }
  
        console.log(data, token);
      } catch (error) {
        console.log(error);
        toast.error("Failed to assign courier");
      }
    };

  useEffect(() => {
    fetchCheckouts();
    fetchServieBoys();
    allProductAvailableToSell();
    fetchCourierList()
  }, []);

  const activeCheckout = conformedCheckout.find(
    (item) => item.checkoutId === activeIndex
  );

  const currentProduct = itemId
    ? availableProducts.find(
        (item) => item.productId === itemId.productId
      )
    : null;

      const openCourierModal = (item) => {
    setDeliveryAssign(item);
  };

  const closeCourierModal = () => {
    setDeliveryAssign(null);
  };

  return (
    <div id="main_content" className="asn-page">
      <Header />

      <div className="page">
        <Section />

        <div className="section-body asn-section">
          {/* Page heading */}
          <div className="asn-page-heading">
            <div>
              <span className="asn-eyebrow">ORDER MANAGEMENT</span>
              <h2>Serial Number & Dispatch</h2>
              <p>
                Assign product serial numbers and manage your order dispatches.
              </p>
            </div>

            <div className="asn-heading-icon">
              <i className="fa fa-barcode" />
            </div>
          </div>

          {/* Summary */}
          <div className="asn-summary">
            <div className="asn-summary-card">
              <div className="asn-summary-icon asn-icon-orange">
                <i className="fa fa-clock-o" />
              </div>
              <div>
                <span>Pending Dispatch</span>
                <strong>{conformedCheckout.length}</strong>
              </div>
            </div>

            <div className="asn-summary-card">
              <div className="asn-summary-icon asn-icon-green">
                <i className="fa fa-truck" />
              </div>
              <div>
                <span>Dispatched Orders</span>
                <strong>{dispatchedCheckout.length}</strong>
              </div>
            </div>

            <div className="asn-summary-card">
              <div className="asn-summary-icon asn-icon-blue">
                <i className="fa fa-barcode" />
              </div>
              <div>
                <span>Selected Serial Numbers</span>
                <strong>{serialNumbers.length}</strong>
              </div>
            </div>
          </div>

          {/* Checkout columns */}
          <div className="asn-orders-grid">
            {/* Pending orders */}
            <section className="asn-panel">
              <div className="asn-panel-heading">
                <div>
                  <h3>
                    <span className="asn-heading-dot asn-dot-orange" />
                    Pending Orders
                  </h3>
                  <p>Orders waiting for serial numbers and dispatch.</p>
                </div>
                <span className="asn-count asn-count-orange">
                  {conformedCheckout.length}
                </span>
              </div>

              <div className="asn-order-list">
                {conformedCheckout.length === 0 ? (
                  <div className="asn-empty">
                    <i className="fa fa-inbox" />
                    <strong>No pending orders</strong>
                    <span>All orders have been dispatched.</span>
                  </div>
                ) : (
                  conformedCheckout.map((item) => (
                    <div
                      key={item.checkoutId}
                      className="asn-order-card asn-pending-card"
                    >
                      <div className="asn-order-top">
                        <span className="asn-checkout-id">
                          #{item.checkoutId}
                        </span>
                        <span className="asn-order-date">
                          <i className="fa fa-calendar" />
                          {dateFormate(item.createdAt)}
                        </span>
                      </div>

                      <div className="asn-customer-row">
                        <div className="asn-customer-icon">
                          <i className="fa fa-user" />
                        </div>
                        <div className="asn-customer-info">
                          <span>Customer</span>
                          <strong>{item.customerName}</strong>
                        </div>
                      </div>

                      <div className="asn-order-meta">
                        <span className="asn-status-pill">
                          {item.orderStatus}
                        </span>
                      </div>

                      <div className="asn-amount-row">
                        <div>
                          <span>Total Amount</span>
                          <strong>
                            ₹{(item.totalAmount || 0).toFixed(2)}
                          </strong>
                        </div>
                        <div>
                          <span>Grand Amount</span>
                          <strong>
                            ₹{(item.grandTotal || 0).toFixed(2)}
                          </strong>
                        </div>
                      </div>

                      <button
                        className="asn-primary-btn asn-full-btn"
                        onClick={() => setActiveIndex(item.checkoutId)}
                      >
                        <i className="fa fa-barcode" />
                        Add Serial Numbers
                        <i className="fa fa-arrow-right asn-btn-arrow" />
                      </button>
                    </div>
                  ))
                )}
              </div>
            </section>

            {/* Dispatched orders */}
            <section className="asn-panel">
              <div className="asn-panel-heading">
                <div>
                  <h3>
                    <span className="asn-heading-dot asn-dot-green" />
                    Dispatched Orders
                  </h3>
                  <p>Orders that have already been dispatched.</p>
                </div>
                <span className="asn-count asn-count-green">
                  {dispatchedCheckout.length}
                </span>
              </div>

              <div className="asn-order-list">
                {dispatchedCheckout.length === 0 ? (
                  <div className="asn-empty">
                    <i className="fa fa-truck" />
                    <strong>No dispatched orders</strong>
                    <span>Dispatched orders will appear here.</span>
                  </div>
                ) : (
                  dispatchedCheckout.map((item) => (
                    <div
                      key={item.checkoutId}
                      className="asn-order-card asn-dispatched-card"
                    >
                      <div className="asn-order-top">
                        <span className="asn-checkout-id">
                          #{item.checkoutId}
                        </span>
                        <span className="asn-order-date">
                          <i className="fa fa-calendar" />
                          {dateFormate(item.createdAt)}
                        </span>
                      </div>

                      <div className="asn-customer-row">
                        <div className="asn-customer-icon">
                          <i className="fa fa-user" />
                        </div>
                        <div className="asn-customer-info">
                          <span>Customer</span>
                          <strong>{item.customerName}</strong>
                        </div>
                      </div>

                      <div className="asn-delivery-info">
                        <i className="fa fa-truck" />
                        <span>Delivery Boy:</span>
                        <strong>
                          {findServiceboy(item.servicePersonId)}
                        </strong>
                      </div>

                      <div className="asn-amount-row">
                        <div>
                          <span>Total Amount</span>
                          <strong>
                            ₹{(item.totalAmount || 0).toFixed(2)}
                          </strong>
                        </div>
                        <div>
                          <span>Grand Amount</span>
                          <strong>
                            ₹{(item.grandTotal || 0).toFixed(2)}
                          </strong>
                        </div>
                      </div>

                      <div className="asn-dispatched-label">
                        <i className="fa fa-check-circle" />
                        Successfully Dispatched
                      </div>
                    </div>
                  ))
                )}
              </div>
            </section>
          </div>
        </div>

        {/* Checkout details modal */}
        {activeIndex !== null && activeCheckout && (
          <div
            className="asn-overlay"
            onClick={() => setActiveIndex(null)}
          >
            <div
              className="asn-modal asn-checkout-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="asn-modal-header">
                <div>
                  <span className="asn-modal-eyebrow">ORDER DETAILS</span>
                  <h3>Checkout #{activeCheckout.checkoutId}</h3>
                </div>

                <button
                  className="asn-close-btn"
                  onClick={() => setActiveIndex(null)}
                >
                  <i className="fa fa-times" />
                </button>
              </div>

              <div className="asn-modal-body">
                <div className="asn-detail-summary">
                  <div>
                    <span>Total Amount</span>
                    <strong>
                      ₹{(activeCheckout.totalAmount || 0).toFixed(2)}
                    </strong>
                  </div>
                  <div>
                    <span>Grand Total</span>
                    <strong>
                      ₹{(activeCheckout.grandTotal || 0).toFixed(2)}
                    </strong>
                  </div>
                </div>

                <div className="asn-detail-row">
                  <div>
                    <span>Customer</span>
                    <strong>{activeCheckout.customerName}</strong>
                  </div>
                  <div>
                    <span>Order Status</span>
                    <strong className="asn-status-pill">
                      {activeCheckout.orderStatus}
                    </strong>
                  </div>
                </div>

                <div className="asn-detail-row">
                  <div>
                    <span>Delivery Address</span>
                    <strong>
                      {activeCheckout.city}, {activeCheckout.pincode}
                    </strong>
                  </div>
                </div>

                <div className="asn-products-heading">
                  <div>
                    <h4>Ordered Products</h4>
                    <p>
                      Add the available serial numbers for each product.
                    </p>
                  </div>
                  <span>{activeCheckout.items?.length || 0} Products</span>
                </div>

                <div className="asn-product-list">
                  {activeCheckout.items.map((product, index) => (
                    <div
                      className="asn-product-card"
                      key={product.productId || index}
                    >
                      <div className="asn-product-main">
                        <img
                          src={baseURL + product.productImage}
                          alt={product.productName}
                          className="asn-product-image"
                        />

                        <div className="asn-product-info">
                          <strong>{product.productName}</strong>
                          <span>Product ID: {product.productId}</span>
                        </div>
                      </div>

                      <div className="asn-product-quantity">
                        <span>Quantity</span>
                        <strong>{product.quantity}</strong>
                      </div>

                      <button
                        className="asn-outline-btn"
                        onClick={() => {
                          setAddingModal("serialNumber");
                          setItemId(product);
                        }}
                      >
                        <i className="fa fa-barcode" />
                        Add Serial Number
                      </button>
                    </div>
                  ))}
                </div>

                <button
                  className="asn-service-btn"
                  onClick={() => setAddingModal("service-boy")}
                >
                  <i className="fa fa-user-plus" />
                  Assign Service Boy
                </button>
                <button
                style={{marginLeft:"20px"}}
                  className="asn-service-btn"
                  onClick={() => openCourierModal(activeCheckout)}
                >
                  <i className="fa fa-user-plus" />
                  Assign Courier
                </button>
              </div>

              <div className="asn-modal-footer">
                <button
                  className="asn-secondary-btn"
                  onClick={() => setActiveIndex(null)}
                >
                  Close
                </button>

                <button
                  className="asn-primary-btn"
                  disabled={load}
                  onClick={() =>
                    dispatchCheckout({
                      checkoutId: activeIndex,
                      customerId: activeCheckout.customerId,
                      dispatchNumber: generateRandomString(),
                      serialNumbers: serialNumbers,
                    })
                  }
                >
                  {load ? (
                    <>
                      <i className="fa fa-spinner fa-spin" />
                      Processing...
                    </>
                  ) : (
                    <>
                      <i className="fa fa-truck" />
                      Dispatch Order
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Service boy modal */}
        {addingModal === "service-boy" && (
          <div
            className="asn-overlay"
            onClick={() => setAddingModal(null)}
          >
            <div
              className="asn-modal asn-small-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="asn-modal-header">
                <div>
                  <span className="asn-modal-eyebrow">DELIVERY MANAGEMENT</span>
                  <h3>Available Service Boys</h3>
                </div>

                <button
                  className="asn-close-btn"
                  onClick={() => setAddingModal(null)}
                >
                  <i className="fa fa-times" />
                </button>
              </div>
                <div className="cc-form-section"
                style={{padding:"10px"}}>
                  <div className="cc-form-section-title">
                    <i className="fa fa-calendar" />
                    <h5>Delivery Schedule</h5>
                  </div>

                  <div className="cc-form-grid">
                    <div className="cc-form-group">
                      <label>Expected Delivery Date</label>
                      <input
                        type="datetime-local"
                        value={expectedDeliveryDate || ""}
                        onChange={(e) =>
                          setExpectedDeliveryDate(e.target.value)
                        }
                      />
                    </div>

                    <div className="cc-form-group">
                      <label>Pickup Date</label>
                      <input
                        type="datetime-local"
                        value={pickupDateTime || ""}
                        onChange={(e) =>
                          setPickupDateTime(e.target.value)
                        }
                      />
                    </div>
                  </div>
                   <div className="cc-form-group cc-form-full">
                      <label>Pickup Address</label>
                      <input
                        type="text"
                        placeholder="Enter pickup address"
                        value={pickupAddress}
                        onChange={(e) =>
                          setPickupAddress(e.target.value)
                        }
                      />
                    </div>
                </div>

              <div className="asn-modal-body">
                {serviceBoys.length === 0 ? (
                  <div className="asn-empty">
                    <i className="fa fa-users" />
                    <strong>No service boys available</strong>
                  </div>
                ) : (
                  <div className="asn-service-list">
                    {serviceBoys.map((item) => (
                      <div
                        className="asn-service-person"
                        key={item.employeeId}
                      >
                        <div className="asn-service-avatar">
                          <i className="fa fa-user" />
                        </div>

                        <div className="asn-service-person-info">
                          <strong>{item.firstName}</strong>
                          <span>ID: {item.employeeId}</span>
                        </div>

                        <button
                          className="asn-primary-btn asn-assign-btn"
                          onClick={() =>
                            addingServiceBoy({
                              commonuserId: item.commonuserId,
                              employeeId: item.employeeId,
                              sellId: activeCheckout.sellId,
                            })
                          }
                        >
                          Assign
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
         {/* COURIER ASSIGNMENT MODAL */}
        {deliveryAssign !== null && (
          <div
            className="cc-modal-overlay"
            onClick={closeCourierModal}
          >
            <div
              className="cc-modal cc-courier-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="cc-modal-header">
                <div>
                  <span className="cc-modal-eyebrow">
                    DELIVERY CONFIGURATION
                  </span>
                  <h3>Assign Courier</h3>
                  <p>
                    Complete the delivery information to confirm this order.
                  </p>
                </div>

                <button
                  type="button"
                  className="cc-modal-close"
                  onClick={closeCourierModal}
                >
                  <i className="fa fa-times" />
                </button>
              </div>

              <div className="cc-modal-content">
                <div className="cc-assignment-order">
                  <div className="cc-assignment-icon">
                    <i className="fa fa-shopping-bag" />
                  </div>

                  <div>
                    <span>Selected Checkout</span>
                    <strong>{deliveryAssign.checkoutId}</strong>
                    <small>{deliveryAssign.customerName}</small>
                  </div>

                  <span className="cc-status cc-status-pending">
                    CREATED
                  </span>
                </div>

                <div className="cc-form-section">
                  <div className="cc-form-section-title">
                    <i className="fa fa-calendar" />
                    <h5>Delivery Schedule</h5>
                  </div>

                  <div className="cc-form-grid">
                    <div className="cc-form-group">
                      <label>Expected Delivery Date</label>
                      <input
                        type="datetime-local"
                        value={expectedDeliveryDate || ""}
                        onChange={(e) =>
                          setExpectedDeliveryDate(e.target.value)
                        }
                      />
                    </div>

                    <div className="cc-form-group">
                      <label>Pickup Date</label>
                      <input
                        type="datetime-local"
                        value={pickupDateTime || ""}
                        onChange={(e) =>
                          setPickupDateTime(e.target.value)
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="cc-form-section">
                  <div className="cc-form-section-title">
                    <i className="fa fa-truck" />
                    <h5>Courier Information</h5>
                  </div>

                  <div className="cc-form-grid">
                    <div className="cc-form-group cc-form-full">
                      <label>Courier Service</label>
                      <select
                        value={selectedCourier?.id || ""}
                        onChange={(e) =>
                          setSelectedCourier(
                            courierList.find(
                              (boy) => boy.id === Number(e.target.value)
                            )
                          )
                        }
                      >
                        <option value="">Select Courier Service</option>

                        {courierList.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.courierServiceName}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="cc-form-group">
                      <label>Tracking Number</label>
                      <input
                        type="text"
                        placeholder="Enter tracking number"
                        value={trackingNumber}
                        onChange={(e) =>
                          setTrackingNumber(e.target.value)
                        }
                      />
                    </div>

                    <div className="cc-form-group">
                      <label>Delivery Cost</label>
                      <div className="cc-input-with-prefix">
                        <span>₹</span>
                        <input
                          type="number"
                          placeholder="Enter delivery cost"
                          value={deliveryCost}
                          onChange={(e) =>
                            setDeliveryCost(e.target.value)
                          }
                        />
                      </div>
                    </div>

                    <div className="cc-form-group cc-form-full">
                      <label>Pickup Address</label>
                      <input
                        type="text"
                        placeholder="Enter pickup address"
                        value={pickupAddress}
                        onChange={(e) =>
                          setPickupAddress(e.target.value)
                        }
                      />
                    </div>

                    <div className="cc-form-group cc-form-full">
                      <label>Remarks</label>
                      <textarea
                        rows="3"
                        placeholder="Add any delivery instructions or remarks..."
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="cc-modal-actions">
                  <button
                    type="button"
                    className="cc-cancel-btn"
                    onClick={closeCourierModal}
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="cc-submit-btn"
                    onClick={handleAssignCourier}
                  >
                    <i className="fa fa-check-circle" />
                    Assign Courier & Confirm
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Serial number selection modal */}
        {addingModal === "serialNumber" && itemId && (
          <div
            className="asn-overlay"
            onClick={() => setAddingModal(null)}
          >
            <div
              className="asn-modal asn-serial-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="asn-modal-header">
                <div>
                  <span className="asn-modal-eyebrow">INVENTORY MANAGEMENT</span>
                  <h3>Select Serial Numbers</h3>
                  <p>
                    Product quantity: <strong>{itemId.quantity}</strong>
                  </p>
                </div>

                <button
                  className="asn-close-btn"
                  onClick={() => setAddingModal(null)}
                >
                  <i className="fa fa-times" />
                </button>
              </div>

              <div className="asn-modal-body">
                <div className="asn-serial-instruction">
                  <i className="fa fa-info-circle" />
                  Select the available serial numbers for this product.
                </div>

                {!currentProduct ||
                !currentProduct.serialNumbers ||
                currentProduct.serialNumbers.length < 1 ? (
                  <div className="asn-empty">
                    <i className="fa fa-barcode" />
                    <strong>No serial numbers available</strong>
                    <span>
                      There are currently no serial numbers to assign to this
                      product.
                    </span>
                  </div>
                ) : (
                  <div className="asn-serial-list">
                    {currentProduct.serialNumbers.map((number, index) => {
                      const isSelected = serialNumbers.find(
                        (item) =>
                          item.serialNumber === number.serialNumber
                      );

                      return (
                        <div
                          className={`asn-serial-card ${
                            isSelected ? "asn-serial-selected" : ""
                          }`}
                          key={number.serialNumber || index}
                        >
                          <div className="asn-serial-info">
                            <div className="asn-serial-icon">
                              <i className="fa fa-barcode" />
                            </div>

                            <div>
                              <strong>{number.serialNumber}</strong>
                              <span>
                                Ear: {number?.ear || "Not specified"}
                              </span>
                            </div>
                          </div>

                          {isSelected ? (
                            <button
                              className="asn-undo-btn"
                              onClick={() =>
                                undoSerialNumber({
                                  productId: itemId.productId,
                                  serialNumber: number.serialNumber,
                                  ear: number.ear || null,
                                  qunatity: itemId.quantity,
                                })
                              }
                            >
                              <i className="fa fa-undo" />
                              Undo
                            </button>
                          ) : (
                            <button
                              className="asn-add-btn"
                              onClick={() =>
                                handleAddSerialNumber({
                                  productId: itemId.productId,
                                  serialNumber: number.serialNumber,
                                  ear: number.ear || null,
                                  quantity: itemId.quantity,
                                })
                              }
                            >
                              <i className="fa fa-plus" />
                              Add
                            </button>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              <div className="asn-modal-footer">
                <span className="asn-selected-count">
                  {serialNumbers.filter(
                    (item) => item.productId === itemId.productId
                  ).length}{" "}
                  selected for this product
                </span>

                <button
                  className="asn-primary-btn"
                  onClick={() => setAddingModal(null)}
                >
                  Done
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Selected serial numbers floating panel */}
        {serialNumbers.length > 0 && (
          <div className="asn-selected-panel">
            <div className="asn-selected-header">
              <div>
                <div className="asn-selected-title">
                  <i className="fa fa-barcode" />
                  Selected Serial Numbers
                </div>
                <span>{serialNumbers.length} serial numbers selected</span>
              </div>

              <button
                className="asn-clear-btn"
                onClick={() => setSerialNumbers([])}
              >
                Clear All
              </button>
            </div>

            <div className="asn-selected-list">
              {serialNumbers.map((item, index) => (
                <div
                  className="asn-selected-item"
                  key={`${item.serialNumber}-${index}`}
                >
                  <div>
                    <span>Serial Number</span>
                    <strong>{item.serialNumber}</strong>
                  </div>
                  <div>
                    <span>Product ID</span>
                    <strong>{item.productId}</strong>
                  </div>
                  <button
                    className="asn-remove-selected"
                    title="Remove serial number"
                    onClick={() => undoSerialNumber(item)}
                  >
                    <i className="fa fa-times" />
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="section-body asn-footer">
          <footer className="footer">
            <div className="container-fluid">
              Copyright © 2025{" "}
              <a href="">
                Technology support By - Siance Software Pvt Ltd
              </a>
              .
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default OrderAddSerialNumber;